/**
 * @file: Colors.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const Neutrals = {
  Black: '#000000',
  Gray1: '#262626',
  Gray2: '#4A4A4A',
  Gray3: '#9498A2',
  Gray4: '#CED1D9',
  Gray5: '#F2F5FD',
  Gray6: 'rgba(0, 0, 0, 0.2)',
  Gray7: '#8c8c8c',
  Gray8: '#F3F3F4',
  Gray9: '#CED1D9',
  Gray10: '#F3F3F4',
  White: '#ffffff',
  Green1: '#12E6C8',
  Green2: '#5AB7DE',
  Purple1: '#A287F4',
  ThroughTeal: 'rgba(119, 255, 236, 0.25)',
  ThroughOrange: 'rgba(255, 132, 94, 0.25)',
  ThroughLime: 'rgba(203, 237, 38, 0.25 )',
  ThroughPurple: 'rgba(162, 135, 244, 0.25)',
  ThroughWhite: 'rgba(255, 255, 255, 0.25)',
  Transparent: 'transparent',
  Orange2: '#FF845E',
  White0_1: 'rgba(255, 255, 255, 0.01)',
  White0_2: 'rgba(255, 255, 255, 0.02)',
  White0_3: 'rgba(255, 255, 255, 0.03)',
  White0_4: 'rgba(255, 255, 255, 0.04)',
  White0_5: 'rgba(255, 255, 255, 0.05)',
  White1: 'rgba(255, 255, 255, 0.1)',
  White1_5: 'rgba(255, 255, 255, 0.15)',
  White2: 'rgba(255, 255, 255, 0.2)',
  White2_5: 'rgba(255, 255, 255, 0.25)',
  White3: 'rgba(255, 255, 255, 0.3)',
  White3_5: 'rgba(255, 255, 255, 0.35)',
  White4: 'rgba(255, 255, 255, 0.4)',
  White4_5: 'rgba(255, 255, 255, 0.45)',
  White5: 'rgba(255, 255, 255, 0.5)',
  White5_5: 'rgba(255, 255, 255, 0.55)',
  White6: 'rgba(255, 255, 255, 0.6)',
  White6_5: 'rgba(255, 255, 255, 0.65)',
  White7: 'rgba(255, 255, 255, 0.7)',
  White7_5: 'rgba(255, 255, 255, 0.75)',
  White8: 'rgba(255, 255, 255, 0.8)',
  White8_5: 'rgba(255, 255, 255, 0.85)',
  White9: 'rgba(255, 255, 255, 0.9)',
  White9_5: 'rgba(255, 255, 255, 0.95)',
};

export const StatusColors = {
  Info: '#2669db',
  Warn: 'rgba(255, 138, 0, 1)',
  Danger: 'rgba(224, 70, 61, 1)',
  Success: '#00aa55',
  Notice: 'rgba(217, 176, 30, 1)',
};

export const Colors = {
  WeixinPrimary: '#04BE02',
  ...Neutrals,
};
